module.exports = __webpack_public_path__ + "static/img/diyimmove12.f9084ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rppghealth/diyimmove12.png
// module id = uIjD
// module chunks = 5